import * as React from "react";
import styled from "react-emotion";
import {Control, Field, Input} from "bloomer";
import Card from "../../../elements/Card";
import Stocks from "../Stocks";
import Fuse from "fuse.js";
import {H2} from "../../../elements/Heading";
import {isEmpty} from "lodash";
import {getSummarizerReport} from "../../../api/models/Summarizer";
import FileSaver from "file-saver";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import ModelContentContainer from "../../../elements/ModelContentContainer";

const options = {
  findAllMatches: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ["ticker", "company"]
};

const ReportLink = styled("a")`
  background: white;
  color: #2f3241;
  border: 1px solid #1c2541;
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px;

  :hover {
    border: 1px solid #1c2541;
    color: white;
    background: #2f3241;
  }
`;

const SearchResultsContainer = styled("div")`
  margin: 10px;
`;

const SearchResult = styled("div")`
  border-bottom: 1px solid lightgrey;
  display: flex;

  :hover {
    cursor: pointer;
    color: white !important;
    background: #2f3241 !important;
  }
`;

const Ticker = styled("span")`
  margin-right: 5px;
  min-width: 50px;
`;

const Company = styled("span")`
  margin-left: 10px;
`;

const InformationContainer = styled("div")`
  display: flex;
`;

const SelectedStock = styled(H2)`
  margin: 0;
  margin-right: 5px;
`;

interface ICompanyTicker {
  ticker: string;
  company: string;
};

const SearchResults = (
  results: ICompanyTicker[],
  selectStock: any
) => {
  const newResults = results.slice(0, 5);
  return newResults.map(r => (
    <SearchResult onClick={() => selectStock(r.ticker, r.company)}>
      <Ticker>{r.ticker}</Ticker>
      <span>|</span>
      <Company>{r.company}</Company>
    </SearchResult>
  ));
};

class Summarizer extends React.Component {
  public state = {
    searchInput: "",
    // @ts-ignore:
    searchResults: [],
    searchPerformed: false,
    // @ts-ignore:
    index: new Fuse(Stocks, options),
    selectedStock: { ticker: "", company: "" },
    searched: false,
    report: new Blob(),
    reportFound: false
  };

  public componentDidMount() {
    SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.SUMMARIZER);
  }

  public downloadReport() {
    const report = new Blob([this.state.report], {
      type: "application/pdf;charset=utf-8"
    });
    FileSaver.saveAs(report, `${this.state.selectedStock.ticker}.pdf`);

    SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.SUMMARIZER);
  }

  public getReport(ticker: string) {
    if (
      typeof ticker === "string" &&
      (ticker.indexOf("NYSE:") >= 0 || ticker.indexOf("NASDAQ:") >= 0 || ticker.indexOf("KRX:") >= 0 )
    ) {;

      const exchangeTicker = ticker.split(":");
      getSummarizerReport(exchangeTicker[1], exchangeTicker[0]).then((response) => {
          if (response && response.data !== '') {
            this.setState({
              report: response.data,
              reportFound: true,
              searched: true
            });
          } else {
            this.setState({
              report: new Blob(),
              reportFound: false,
              searched: true
            });
          }
        }).catch((error) => {
          if (ErrorUtils.requestLimitExceeded(error.response)) {
              this.setState({
                  report: new Blob(),
                  reportFound: false,
                  searched: true
              });
              toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
          }
      });
    }
  }

  public render() {
    return <ModelContentContainer>
        <Card>
          <Field>
            <Control>
              <Input
                type="text"
                placeholder="Enter stock ticker, like 'AAPL'"
                value={this.state.searchInput}
                onChange={this.handleChange}
              />
            </Control>
          </Field>
          {isEmpty(this.state.selectedStock.ticker) ? (
            <SearchResultsContainer>
              {SearchResults(this.state.searchResults, this.selectStock)}
              {
                this.state.searchPerformed && isEmpty(this.state.searchResults) && <div>
                  <span>Stock ticker not found</span>
                </div>
              }
            </SearchResultsContainer>
          ) : (
            <div style={{ display: "flex", marginLeft: "5px" }}>
              <SelectedStock>{this.state.selectedStock.ticker}</SelectedStock>
              <SelectedStock> | </SelectedStock>
              <SelectedStock>
                {" "}
                {this.state.selectedStock.company.slice(0, 30)}{" "}
              </SelectedStock>
            </div>
          )}

          {!isEmpty(this.state.selectedStock.ticker) && !this.state.searched ? (
            this.getReport(this.state.selectedStock.ticker)
          ) : (
            <></>
          )}
          {!isEmpty(this.state.selectedStock.ticker) ? (
            this.state.reportFound ? (
              <InformationContainer>
                <ReportLink onClick={() => this.downloadReport()}>
                  Download report
                </ReportLink>
              </InformationContainer>
            ) : (
              <p>No report available.</p>
            )
          ) : (
            <></>
          )}
        </Card>
      </ModelContentContainer>;
  }

  private handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    const results = this.state.index.search(value.trim());
    this.setState({
      searchPerformed: value.trim().length > 0,
      searchResults: results,
      searchInput: e.currentTarget.value,
      selectedStock: ""
    });
  };

  private selectStock = (ticker: string, company: string) => {
    this.setState({ selectedStock: { ticker, company }, searched: false });
  };
}

export default Summarizer;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Summarizer/SummarizerModel.tsx